export default __webpack_public_path__ + "static/media/program_questions.5c6d6bdf.jpeg";